import { render, staticRenderFns } from "./screen-head.vue?vue&type=template&id=2c145b9a&scoped=true&"
import script from "./screen-head.vue?vue&type=script&lang=ts&"
export * from "./screen-head.vue?vue&type=script&lang=ts&"
import style0 from "./screen-head.vue?vue&type=style&index=0&id=2c145b9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c145b9a",
  null
  
)

export default component.exports